import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

import { API_URL } from '../config/api';

const Forget = () => {
  const [formData, setFormData] = useState({
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email.trim())) {
      newErrors.email = 'Please enter a valid email address';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (!API_URL) {
      toast.error('API URL is not configured. Please set REACT_APP_API_URL in environment variables.');
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        action: 'forgot-employee-password',
        email: formData.email.trim()
      };

      const response = await axios.post(API_URL, payload, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const result = response.data;

      if (result?.success) {
        toast.success(result?.message || 'Password reset link has been sent to your email');
        setIsSubmitted(true);
      } else {
        toast.error(result?.message || 'Failed to send password reset link. Please try again.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Something went wrong. Please try again.';
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="login-wrapper">
        <div className="login-card">
          {/* Left Side - Quotes */}
          <div className="login-left">
            <div className="login-left-content">
              <div className="quote-section">
                {/* <h1 className="quote-title">Welcome to </h1> */}
                <h1 className="quote-title1">InstaTenders HR Portal!</h1>
                <p className="quote-text">
                  அன்புஈனும் ஆர்வம் உடைமை அதுஈனும்
                  நண்பு என்னும் நாடாச் சிறப்பு.
                </p>
                <p className="quote-meaning">
                  From love fond yearning springs for union sweet of minds;
                  And that the bond of rare excelling friendship binds.
                </p>
                <p className="quote-author">— திருவள்ளுவர் </p>
              </div>
            </div>
          </div>

          {/* Right Side - Forgot Password Form */}
          <div className="login-right">
            <div className="login-body">
              {/* Logo Section */}
              <div className="logo-container-right">
                <img
                  src="/assets/img/Website_logo_color logo-black text-1.png"
                  alt="Company Logo"
                  className="login-logo-right"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div className="logo-placeholder-right" style={{ display: 'none' }}>
                  <i className="fas fa-building"></i>
                </div>
              </div>

              {!isSubmitted ? (
                <>
                  {/* <div className="form-header-text">
                    <h2 className="form-title">Forgot Password</h2>
                  </div> */}

                  <form onSubmit={handleSubmit} noValidate>
                    {/* Email Field */}
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">
                        Email Address
                      </label>
                      <div className="input-wrapper">
                        <div className="input-icon">
                          <i className="fas fa-envelope"></i>
                        </div>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className={`form-input ${errors.email ? 'error' : ''}`}
                          placeholder="Enter your email address"
                          value={formData.email}
                          onChange={handleChange}
                          autoComplete="email"
                          aria-invalid={errors.email ? 'true' : 'false'}
                          aria-describedby={errors.email ? 'email-error' : undefined}
                        />
                      </div>
                      {errors.email && (
                        <span className="error-message" id="email-error" role="alert">
                          <i className="fas fa-exclamation-circle"></i> {errors.email}
                        </span>
                      )}
                    </div>

                    {/* Submit Button */}
                    <button
                      type="submit"
                      className={`login-button ${isLoading ? 'loading' : ''}`}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <i className="fas fa-spinner fa-spin"></i>
                          <span>Sending...</span>
                        </>
                      ) : (
                        <>
                          <span>Submit</span>
                          {/* <i className="fas fa-arrow-right"></i> */}
                        </>
                      )}
                    </button>
                  </form>

                  {/* Back to Login */}
                  <div className="form-options" style={{ marginTop: '24px', justifyContent: 'center' }}>
                    <Link to="/" className="forgot-link">
                      {/* <i className="fas fa-arrow-left"></i>  */}
                      Back to Login
                    </Link>
                  </div>
                </>
              ) : (
                <div className="success-message">
                  <div className="success-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <h2 className="form-title">Check Your Email</h2>
                  <p className="form-subtitle">
                    We've sent a password reset link to <strong>{formData.email}</strong>
                  </p>
                  <p className="form-subtitle" style={{ marginTop: '16px' }}>
                    Please check your email and click on the link to reset your password.
                  </p>
                  <div className="form-options" style={{ marginTop: '32px', justifyContent: 'center' }}>
                    <Link to="/" className="forgot-link">
                      <i className="fas fa-arrow-left"></i> Back to Login
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forget;
